$(document).ready(function () {
  $('.swiper-quotes').each(function () {
    const featuredCollectionSwiper = new Swiper(this, {
      direction: 'horizontal',
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 5000,
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
    });
  });


});
